import React, { useEffect, useState } from "react";
import MudrexIcon from "../ui/MudrexIcon/MudrexIcon";
import AttachFiles from "./AttachFiles";

interface Props {
  documents: any[];
  setAreCompulsoryDocumentsUploaded: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setUploadedDocuments: React.Dispatch<React.SetStateAction<any[]>>;
  setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
  uploadedDocuments: any[];
}

const DocumentsRequired: React.FC<Props> = ({
  documents,
  setAreCompulsoryDocumentsUploaded,
  setUploadedDocuments,
  setIsEdited,
  uploadedDocuments,
}) => {
  useEffect(() => {
    setAreCompulsoryDocumentsUploaded(
      documents?.every(({ optional, tag, status }) => {
        if (!optional && status !== "COMPLETED") {
          return uploadedDocuments.some(
            ({ document_tag }) => document_tag === tag
          );
        }
        return true;
      })
    );
  }, [JSON.stringify(uploadedDocuments), JSON.stringify(documents)]);

  return (
    <div className="bg-white p-4 rounded-b-lg shadow-md">
      <div className="flex flex-row items-center bg-gradient-warning-light p-3 rounded-lg mb-6">
        <MudrexIcon icon="Info" size={40} color="#F28F07" />
        <p className="text-12-r ml-[10px]">
          <strong>Remove password from password-protected docs</strong>
          <br></br>
          Attachments must be authentic and valid. Invalid and
          password-protected documents will lead to rejection.
        </p>
      </div>
      {documents?.map((document) => (
        <AttachFiles
          document={document}
          setUploadedDocuments={setUploadedDocuments}
          setIsEdited={setIsEdited}
          uploadedDocuments={uploadedDocuments}
        />
      ))}
    </div>
  );
};

export default DocumentsRequired;
